// extracted by mini-css-extract-plugin
module.exports = {"page":"_5xx_page__2hmji","container":"_5xx_container__3QaZ2","fontSizeAdjust":"_5xx_fontSizeAdjust__1WMlR","buttonGroup":"_5xx_buttonGroup__3oXnm"};